<div class="change-password-dialog">
  <h2 mat-dialog-title>{{ 'changePasswordDialog.title' | translate }}</h2>
  
  <mat-dialog-content>
    @if (isFederatedUser() === undefined) {
      <div class="loading-shade">
        <mat-spinner diameter="50"></mat-spinner>
        <p>{{ 'changePasswordDialog.loading' | translate }}</p>
      </div>
    }

    @if (isFederatedUser() === true) {
      <div>
        <p class="info-text federated-info">
          {{ 'changePasswordDialog.federatedInfo' | translate }}
        </p>
      </div>
    }

    @if (isFederatedUser() === false && changePasswordForm) {
      <form [formGroup]="changePasswordForm!" (ngSubmit)="onSubmit()">
        <div class="field-container">
          <label class="field-label">{{ 'changePasswordDialog.oldPasswordPlaceholder' | translate }}</label>
          <mat-form-field appearance="fill" class="full-width-field with-border">
            <input matInput formControlName="oldPassword" [placeholder]="'changePasswordDialog.oldPasswordPlaceholder' | translate" [type]="hideOldPassword() ? 'password' : 'text'" required>
            <button mat-icon-button matSuffix (click)="hideOldPassword.set(!hideOldPassword())" type="button" [attr.aria-label]="'accessibility.hideShowOldPassword' | translate" tabindex="-1">
              <mat-icon>{{hideOldPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (changePasswordForm.get('oldPassword')?.hasError('required')) {
              <mat-error>
                {{ 'changePasswordDialog.validation.oldPasswordRequired' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field-container">
          <label class="field-label">{{ 'changePasswordDialog.newPasswordPlaceholder' | translate }}</label>
          <mat-form-field appearance="fill" class="full-width-field with-border">
            <input matInput formControlName="password" [placeholder]="'changePasswordDialog.newPasswordPlaceholder' | translate" [type]="hideNewPassword() ? 'password' : 'text'" required>
            <button mat-icon-button matSuffix (click)="hideNewPassword.set(!hideNewPassword())" type="button" [attr.aria-label]="'accessibility.hideShowNewPassword' | translate" tabindex="-1">
              <mat-icon>{{hideNewPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (changePasswordForm.get('password')?.hasError('required')) {
              <mat-error>
                {{ 'changePasswordDialog.validation.newPasswordRequired' | translate }}
              </mat-error>
            }
            @if (changePasswordForm.get('password')?.hasError('minlength')) {
              <mat-error>
                {{ 'changePasswordDialog.validation.minLength' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field-container">
          <label class="field-label">{{ 'changePasswordDialog.confirmPasswordPlaceholder' | translate }}</label>
          <mat-form-field appearance="fill" class="full-width-field with-border">
            <input matInput formControlName="confirmPassword" [placeholder]="'changePasswordDialog.confirmPasswordPlaceholder' | translate" [type]="hideConfirmPassword() ? 'password' : 'text'" required>
            <button mat-icon-button matSuffix (click)="hideConfirmPassword.set(!hideConfirmPassword())" type="button" [attr.aria-label]="'accessibility.hideShowConfirmPassword' | translate" tabindex="-1">
              <mat-icon>{{hideConfirmPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (changePasswordForm.get('confirmPassword')?.hasError('required')) {
              <mat-error>
                {{ 'changePasswordDialog.validation.confirmPasswordRequired' | translate }}
              </mat-error>
            }
            @if (changePasswordForm.hasError('passwordMismatch') && changePasswordForm.get('confirmPassword')?.touched) {
              <mat-error>
                {{ 'changePasswordDialog.validation.passwordMismatch' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        @if (errorMessage()) {
          <mat-error class="error-message">
            {{ errorMessage() }}
          </mat-error>
        }
      </form>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-stroked-button (click)="onCancel()" [disabled]="isLoading()">
      {{ 'deletePersonalDataDialog.cancel' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="onSubmit()" 
            [disabled]="!changePasswordForm?.valid || isLoading() || isFederatedUser()">
      @if (isLoading()) {
        <mat-spinner diameter="20"></mat-spinner>
      }
      @if (!isLoading()) {
        <span>{{ 'changePasswordDialog.submit' | translate }}</span>
      }
    </button>
  </mat-dialog-actions>
</div>
